import { render, staticRenderFns } from "./RecoverPasswordNew.vue?vue&type=template&id=47e9d52c&scoped=true&"
import script from "./RecoverPasswordNew.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordNew.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordNew.vue?vue&type=style&index=0&id=47e9d52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9d52c",
  null
  
)

export default component.exports